import { allChances } from "./allChances"

const cornerCellSize = 125
const totalSizeX = 900
const totalSizeY = 900

export const bankOrder = 100
const normalCellSize = (totalSizeX - 250) / 9
export const getPropertyToOwnerMap = (
  game: IGame
): Map<number, PlayerOrder> => {
  const map: Map<number, PlayerOrder> = new Map()
  const myMapDesign = mapDesigns.find((map) => map.id === game.settings.mapId)
  myMapDesign.cells.forEach((cell) => {
    const owner = game.situation.players.find((player) =>
      player.properties.includes(cell.order)
    )
    const ownerOrder = owner?.order === undefined ? 100 : owner.order
    map.set(cell.order, ownerOrder)
  })
  return map
}
const stationRents = [25, 50, 100, 200]
const stationRentCalculator: CalculateCustomRentFunction = (
  game,
  map,
  playerOrder
) => {
  const propertyToOwnerMap = getPropertyToOwnerMap(game)
  const fellowProperties =
    game.settings.mapId === "0" ? [5, 15, 25, 35] : [4, 12, 20, 28]
  const fellowActiveProperties = fellowProperties.filter((order) => {
    const cell = map.cells.find((cell) => cell.order === order)
    return !cell.propertyDetails.mortgaged
  })

  const fellowPropertyOwners = fellowActiveProperties.map((propertyOrder) =>
    propertyToOwnerMap.get(propertyOrder)
  )

  const ownedByGivenPlayerCount = fellowPropertyOwners.filter(
    (owner) => owner === playerOrder
  ).length

  return stationRents[ownedByGivenPlayerCount - 1]
}
export const utilityStoreRentCalculator: CalculateCustomRentFunction = (
  game,
  map,
  ownerOrder,
  playerOrder,
  roll: DiceRoll
) => {
  const fellowProperties = [12, 28]
  const propertyToOwnerMap = getPropertyToOwnerMap(game)
  const fellowActiveProperties = fellowProperties.filter((order) => {
    const cell = map.cells.find((cell) => cell.order === order)
    return !cell.propertyDetails.mortgaged
  })
  const fellowPropertyOwners = fellowActiveProperties.map((propertyOrder) =>
    propertyToOwnerMap.get(propertyOrder)
  )
  const ownedByGivenPlayerCount = fellowPropertyOwners.filter(
    (owner) => owner === ownerOrder
  ).length
  const player = game.situation.players.find(
    (player) => player.order === playerOrder
  )
  const lastRollOfActivePlayer =
    player.rollHistory[player.rollHistory.length - 1]
  const totalRoll = lastRollOfActivePlayer[0] + lastRollOfActivePlayer[1]
  if (ownedByGivenPlayerCount === 1) {
    return totalRoll * 4
  } else return totalRoll * 10
  // return stationRents[ownedByGivenPlayerCount - 1];
}

export const mapDesigns: IMapDesign[] = [
  {
    name: "Standard",
    allChances: allChances,
    img: "",
    // Continue with other Chance cards following the same structure...
    allCommunityChests: [],
    id: "0",
    cells: [
      {
        type: "custom",
        border: 2,
        direction: "horizontal",
        order: 0,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Morocco",
          price: 60,
          groupId: "0",
          rentData: {
            base: 10,
            houses: [10, 30, 90, 160],
            hotel: [250],
            upgradeItems: [
              { count: 1, rent: 60, price: 40 },
              { count: 2, rent: 110, price: 60 },
              { count: 3, rent: 200, price: 80 },
            ],
          },
          mortgagedPrice: 30,
        },
        order: 1,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Algeria",
          price: 60,
          groupId: "0",
          rentData: {
            base: 10,
            houses: [10, 30, 90, 160],
            hotel: [250],
            upgradeItems: [
              { count: 1, rent: 60, price: 40 },
              { count: 2, rent: 110, price: 60 },
              { count: 3, rent: 200, price: 80 },
            ],
          },
          mortgagedPrice: 30,
        },
        order: 2,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Tunisia",
          price: 60,
          groupId: "0",
          rentData: {
            base: 10,
            houses: [20, 60, 180, 320],
            hotel: [450],
            upgradeItems: [
              { count: 1, rent: 60, price: 40 },
              { count: 2, rent: 110, price: 60 },
              { count: 3, rent: 200, price: 80 },
            ],
          },
          mortgagedPrice: 30,
        },
        order: 3,
      },
      // {
      //   type: "property",
      //   border: 2,
      //   direction: "horizontal",
      //   propertyDetails: {
      //     name: "Whitechapel Road",
      //     price: 60,
      //     groupId: "0",
      //     rentData: {
      //       base: 10,
      //       houses: [20, 60, 180, 320],
      //       hotel: [450],
      //       upgradeItems: [
      //         { count: 1, rent: 60, price: 40 },
      //         { count: 2, rent: 105, price: 60 },
      //         { count: 3, rent: 180, price: 80 },
      //       ],
      //     },
      //     mortgagedPrice: 30,
      //   },
      //   order: 4,
      // },
      {
        type: "tax",
        taxDetails: { name: "Income Tax", price: 200 },
        border: 2,
        direction: "horizontal",
        order: 4,
      },
      // {
      //   type: "tax",
      //   taxDetails: { name: "Income Tax", price: 200 },
      //   border: 2,
      //   direction: "horizontal",
      //   order: 4,
      // },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Airport",
          price: 200,
          groupId: "8",
          mortgagedPrice: 100,
          calculateCustomRent: stationRentCalculator,
        },
        order: 5,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Peru",
          price: 100,
          groupId: "1",
          rentData: {
            base: 20,
            houses: [15, 45, 135, 200],
            hotel: [275],
            upgradeItems: [
              { count: 1, rent: 60, price: 40 },
              { count: 2, rent: 120, price: 60 },
              { count: 3, rent: 250, price: 80 },
            ],
          },
          mortgagedPrice: 50,
        },
        order: 6,
      },
      {
        type: "action",
        border: 2,
        direction: "horizontal",
        order: 7,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Brazil",
          price: 100,
          groupId: "1",
          rentData: {
            base: 20,
            houses: [15, 45, 135, 200],
            hotel: [275],
            upgradeItems: [
              { count: 1, rent: 60, price: 40 },
              { count: 2, rent: 110, price: 60 },
              { count: 3, rent: 230, price: 80 },
            ],
          },
          mortgagedPrice: 50,
        },
        order: 8,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Chile",
          price: 120,
          groupId: "1",
          rentData: {
            base: 20,
            houses: [20, 50, 150, 225],
            hotel: [300],
            upgradeItems: [
              { count: 1, rent: 60, price: 40 },
              { count: 2, rent: 110, price: 60 },
              { count: 3, rent: 230, price: 80 },
            ],
          },
          mortgagedPrice: 60,
        },
        order: 9,
      },
      {
        type: "decision-hub",
        border: 2,
        direction: "vertical",
        order: 10,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "China",
          price: 140,
          groupId: "2",
          rentData: {
            base: 30,
            houses: [25, 75, 225, 312.5],
            hotel: [375],
            upgradeItems: [
              { count: 1, rent: 110, price: 60 },
              { count: 2, rent: 170, price: 90 },
              { count: 3, rent: 320, price: 120 },
            ],
          },
          mortgagedPrice: 70,
        },
        order: 11,
      },
      {
        type: "action",
        border: 2,
        direction: "vertical",
        // propertyDetails: {
        //   name: "Electric Company",
        //   price: 150,
        //   groupId: "9",
        //   mortgagedPrice: 75,
        //   calculateCustomRent: utilityStoreRentCalculator,
        // },
        order: 12,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Korea",
          price: 140,
          groupId: "2",
          rentData: {
            base: 30,
            houses: [25, 75, 225, 312.5],
            hotel: [375],
            upgradeItems: [
              { count: 1, rent: 110, price: 60 },
              { count: 2, rent: 170, price: 90 },
              { count: 3, rent: 320, price: 120 },
            ],
          },
          mortgagedPrice: 70,
        },
        order: 13,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Japan",
          price: 140,
          groupId: "2",
          rentData: {
            base: 30,
            houses: [30, 90, 250, 350],
            hotel: [450],
            upgradeItems: [
              { count: 1, rent: 110, price: 60 },
              { count: 2, rent: 170, price: 90 },
              { count: 3, rent: 320, price: 120 },
            ],
          },
          mortgagedPrice: 80,
        },
        order: 14,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Railway Station",
          price: 200,
          groupId: "8",
          mortgagedPrice: 100,
          calculateCustomRent: stationRentCalculator,
        },
        order: 15,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Mexico",
          price: 180,
          groupId: "3",
          rentData: {
            base: 40,
            houses: [35, 100, 275, 375],
            hotel: [475],
            upgradeItems: [
              { count: 1, rent: 120, price: 60 },
              { count: 2, rent: 200, price: 90 },
              { count: 3, rent: 350, price: 120 },
            ],
          },
          mortgagedPrice: 90,
        },
        order: 16,
      },
      {
        type: "action",
        border: 2,
        direction: "vertical",
        order: 17,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Canada",
          price: 180,
          groupId: "3",
          rentData: {
            base: 40,
            houses: [35, 100, 275, 375],
            hotel: [475],
            upgradeItems: [
              { count: 1, rent: 120, price: 60 },
              { count: 2, rent: 200, price: 90 },
              { count: 3, rent: 350, price: 120 },
            ],
          },
          mortgagedPrice: 90,
        },
        order: 18,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "USA",
          price: 200,
          groupId: "3",
          rentData: {
            base: 40,
            houses: [40, 100, 300, 450],
            hotel: [600],
            upgradeItems: [
              { count: 1, rent: 90, price: 60 },
              { count: 2, rent: 200, price: 90 },
              { count: 3, rent: 350, price: 120 },
            ],
          },
          mortgagedPrice: 100,
        },
        order: 19,
      },
      {
        type: "custom",
        border: 2,
        direction: "horizontal",
        order: 20,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Spain",
          price: 220,
          groupId: "4",
          rentData: {
            base: 50,
            houses: [45, 125, 350, 437.5],
            hotel: [525],
            upgradeItems: [
              { count: 1, rent: 160, price: 80 },
              { count: 2, rent: 250, price: 120 },
              { count: 3, rent: 460, price: 160 },
            ],
          },
          mortgagedPrice: 110,
        },
        order: 21,
      },
      {
        type: "action",
        border: 2,
        direction: "horizontal",
        order: 22,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "France",
          price: 220,
          groupId: "4",
          rentData: {
            base: 50,
            houses: [45, 125, 350, 437.5],
            hotel: [525],
            upgradeItems: [
              { count: 1, rent: 160, price: 80 },
              { count: 2, rent: 250, price: 120 },
              { count: 3, rent: 460, price: 160 },
            ],
          },
          mortgagedPrice: 110,
        },
        order: 23,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Germany",
          price: 240,
          groupId: "4",
          rentData: {
            base: 50,
            houses: [50, 150, 375, 462.5],
            hotel: [550],
            upgradeItems: [
              { count: 1, rent: 160, price: 80 },
              { count: 2, rent: 250, price: 120 },
              { count: 3, rent: 460, price: 160 },
            ],
          },
          mortgagedPrice: 120,
        },
        order: 24,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Dock",
          price: 200,
          groupId: "8",
          calculateCustomRent: stationRentCalculator,
          mortgagedPrice: 100,
        },
        order: 25,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Oman",
          price: 260,
          groupId: "5",
          rentData: {
            base: 60,
            houses: [55, 165, 400, 550],
            hotel: [575],
            upgradeItems: [
              { count: 1, rent: 180, price: 80 },
              { count: 2, rent: 290, price: 120 },
              { count: 3, rent: 500, price: 160 },
            ],
          },
          mortgagedPrice: 130,
        },
        order: 26,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "UAE",
          price: 260,
          groupId: "5",
          rentData: {
            base: 60,
            houses: [55, 165, 400, 550],
            hotel: [575],
            upgradeItems: [
              { count: 1, rent: 180, price: 80 },
              { count: 2, rent: 290, price: 120 },
              { count: 3, rent: 500, price: 160 },
            ],
          },
          mortgagedPrice: 130,
        },
        order: 27,
      },
      {
        type: "action",
        border: 2,
        direction: "horizontal",
        order: 28,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Qatar",
          price: 280,
          groupId: "5",
          rentData: {
            base: 60,
            houses: [60, 180, 425, 600],
            hotel: [637.5],
            upgradeItems: [
              { count: 1, rent: 180, price: 80 },
              { count: 2, rent: 290, price: 120 },
              { count: 3, rent: 500, price: 160 },
            ],
          },
          mortgagedPrice: 140,
        },
        order: 29,
      },
      {
        type: "decision-hub",
        border: 2,
        direction: "horizontal",
        order: 30,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Norway",
          price: 300,
          groupId: "6",
          rentData: {
            base: 70,
            houses: [65, 195, 450, 550],
            hotel: [637.5],
            upgradeItems: [
              { count: 1, rent: 230, price: 100 },
              { count: 2, rent: 380, price: 150 },
              { count: 3, rent: 650, price: 200 },
            ],
          },
          mortgagedPrice: 150,
        },
        order: 31,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Sweden",
          price: 300,
          groupId: "6",
          rentData: {
            base: 70,
            houses: [65, 195, 450, 550],
            hotel: [637.5],
            upgradeItems: [
              { count: 1, rent: 230, price: 100 },
              { count: 2, rent: 380, price: 150 },
              { count: 3, rent: 650, price: 200 },
            ],
          },
          mortgagedPrice: 150,
        },
        order: 32,
      },
      {
        type: "action",
        border: 2,
        direction: "vertical",
        order: 33,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Finland",
          price: 320,
          groupId: "6",
          rentData: {
            base: 70,
            houses: [75, 225, 500, 600],
            hotel: [700],
            upgradeItems: [
              { count: 1, rent: 230, price: 100 },
              { count: 2, rent: 380, price: 150 },
              { count: 3, rent: 650, price: 200 },
            ],
          },
          mortgagedPrice: 160,
        },
        order: 34,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Bus Station",
          price: 200,
          groupId: "8",
          calculateCustomRent: stationRentCalculator,
          mortgagedPrice: 100,
        },
        order: 35,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Greece",
          price: 350,
          groupId: "7",
          rentData: {
            base: 80,
            houses: [90, 250, 550, 650],
            hotel: [750],
            upgradeItems: [
              { count: 1, rent: 260, price: 100 },
              { count: 2, rent: 410, price: 150 },
              { count: 3, rent: 680, price: 200 },
            ],
          },
          mortgagedPrice: 175,
        },
        order: 36,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",

        propertyDetails: {
          name: "UK",
          price: 350,
          groupId: "7",
          rentData: {
            base: 80,
            houses: [100, 300, 700, 850],
            hotel: [1000],
            upgradeItems: [
              { count: 1, rent: 260, price: 100 },
              { count: 2, rent: 410, price: 150 },
              { count: 3, rent: 680, price: 200 },
            ],
          },
          mortgagedPrice: 200,
        },
        order: 37,
      },
      {
        type: "action",
        border: 2,
        direction: "vertical",
        order: 38,
      },

      // {
      //   type: "tax",
      //   taxDetails: {
      //     name: "Super Tax",
      //     price: 100,
      //   },
      //   border: 2,
      //   direction: "vertical",
      //   order: 38,
      // },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Ireland",
          price: 400,
          groupId: "7",
          rentData: {
            base: 80,
            houses: [100, 300, 700, 850],
            hotel: [1000],
            upgradeItems: [
              { count: 1, rent: 260, price: 100 },
              { count: 2, rent: 410, price: 150 },
              { count: 3, rent: 680, price: 200 },
            ],
          },
          mortgagedPrice: 200,
        },
        order: 39,
      },
      // Continue in the same way for the remaining cells...
    ],
    groups: [
      {
        color: "#8B5A2B",
        id: "0",
        type: "classic",
        withStrip: true,
        housePrice: 50,
        propertiesCount: 3,
      },

      {
        color: "#9B59B6",
        id: "1",
        type: "classic",
        withStrip: true,
        housePrice: 50,
        propertiesCount: 3,
      },
      {
        color: "#FF6F61",
        id: "2",
        type: "classic",
        withStrip: true,
        housePrice: 100,
        propertiesCount: 3,
      },
      {
        color: "#E08A3C",
        id: "3",
        type: "classic",
        withStrip: true,
        housePrice: 100,
        propertiesCount: 3,
      },
      {
        color: "#3B5998",
        id: "4",
        type: "classic",
        withStrip: true,
        housePrice: 150,
        propertiesCount: 3,
      },
      {
        color: "#D4AC0D",
        id: "5",
        type: "classic",
        withStrip: true,
        housePrice: 150,
        propertiesCount: 3,
      },
      {
        color: "#2ECC71",
        id: "6",
        type: "classic",
        withStrip: true,
        housePrice: 200,
        propertiesCount: 3,
      },
      {
        color: "#D32B2B",
        id: "7",
        type: "classic",
        withStrip: true,
        housePrice: 200,
        propertiesCount: 3,
      },
      {
        color: "#6E7681",
        id: "8",
        type: "classic",
        propertiesCount: 4,
      },
      {
        color: "#6E7681",
        id: "9",
        type: "classic",
      },
    ],
    size: { x: totalSizeX, y: totalSizeY },
  },
  {
    name: "Mini map",
    img: "",
    allChances: allChances,
    allCommunityChests: [],
    id: "1",
    cells: [
      {
        type: "custom",
        border: 2,
        direction: "horizontal",
        order: 0,
      },
      // Removed Morocco (order 1) from group 0
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Algeria",
          price: 60,
          groupId: "0",
          rentData: {
            base: 10,
            houses: [10, 30, 90, 160],
            hotel: [250],
            upgradeItems: [
              { count: 1, rent: 60, price: 40 },
              { count: 2, rent: 110, price: 60 },
              { count: 3, rent: 200, price: 80 },
            ],
          },
          mortgagedPrice: 30,
        },
        order: 1,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Tunisia",
          price: 60,
          groupId: "0",
          rentData: {
            base: 10,
            houses: [20, 60, 180, 320],
            hotel: [450],
            upgradeItems: [
              { count: 1, rent: 60, price: 40 },
              { count: 2, rent: 110, price: 60 },
              { count: 3, rent: 200, price: 80 },
            ],
          },
          mortgagedPrice: 30,
        },
        order: 2,
      },
      {
        type: "tax",
        taxDetails: { name: "Income Tax", price: 200 },
        border: 2,
        direction: "horizontal",
        order: 3,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Airport",
          price: 200,
          groupId: "8",
          mortgagedPrice: 100,
          calculateCustomRent: stationRentCalculator,
        },
        order: 4,
      },
      // Removed Norway (order 6) from group 1

      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Brazil",
          price: 100,
          groupId: "1",
          rentData: {
            base: 20,
            houses: [15, 45, 135, 200],
            hotel: [275],
            upgradeItems: [
              { count: 1, rent: 60, price: 40 },
              { count: 2, rent: 110, price: 60 },
              { count: 3, rent: 230, price: 80 },
            ],
          },
          mortgagedPrice: 50,
        },
        order: 5,
      },
      {
        type: "action",
        border: 2,
        direction: "horizontal",
        order: 6,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Chile",
          price: 120,
          groupId: "1",
          rentData: {
            base: 20,
            houses: [20, 50, 150, 225],
            hotel: [300],
            upgradeItems: [
              { count: 1, rent: 60, price: 40 },
              { count: 2, rent: 110, price: 60 },
              { count: 3, rent: 230, price: 80 },
            ],
          },
          mortgagedPrice: 60,
        },
        order: 7,
      },
      {
        type: "decision-hub",
        border: 2,
        direction: "vertical",
        order: 8,
      },
      // Removed Greece (order 11) from group 2

      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Korea",
          price: 140,
          groupId: "2",
          rentData: {
            base: 30,
            houses: [25, 75, 225, 312.5],
            hotel: [375],
            upgradeItems: [
              { count: 1, rent: 110, price: 60 },
              { count: 2, rent: 170, price: 90 },
              { count: 3, rent: 320, price: 120 },
            ],
          },
          mortgagedPrice: 70,
        },
        order: 9,
      },
      {
        type: "action",
        border: 2,
        direction: "vertical",
        order: 10,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Japan",
          price: 140,
          groupId: "2",
          rentData: {
            base: 30,
            houses: [30, 90, 250, 350],
            hotel: [450],
            upgradeItems: [
              { count: 1, rent: 110, price: 60 },
              { count: 2, rent: 170, price: 90 },
              { count: 3, rent: 320, price: 120 },
            ],
          },
          mortgagedPrice: 80,
        },
        order: 11,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Railway Station",
          price: 200,
          groupId: "8",
          mortgagedPrice: 100,
          calculateCustomRent: stationRentCalculator,
        },
        order: 12,
      },
      // Removed Poland (order 16) from group 3

      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Canada",
          price: 180,
          groupId: "3",
          rentData: {
            base: 40,
            houses: [35, 100, 275, 375],
            hotel: [475],
            upgradeItems: [
              { count: 1, rent: 120, price: 60 },
              { count: 2, rent: 200, price: 90 },
              { count: 3, rent: 350, price: 120 },
            ],
          },
          mortgagedPrice: 90,
        },
        order: 13,
      },
      {
        type: "action",
        border: 2,
        direction: "vertical",
        order: 14,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "USA",
          price: 200,
          groupId: "3",
          rentData: {
            base: 40,
            houses: [40, 100, 300, 450],
            hotel: [600],
            upgradeItems: [
              { count: 1, rent: 90, price: 60 },
              { count: 2, rent: 200, price: 90 },
              { count: 3, rent: 350, price: 120 },
            ],
          },
          mortgagedPrice: 100,
        },
        order: 15,
      },
      {
        type: "custom",
        border: 2,
        direction: "horizontal",
        order: 16,
      },
      // Removed France (order 21) from group 4

      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Germany",
          price: 220,
          groupId: "4",
          rentData: {
            base: 50,
            houses: [45, 125, 350, 437.5],
            hotel: [525],
            upgradeItems: [
              { count: 1, rent: 160, price: 80 },
              { count: 2, rent: 250, price: 120 },
              { count: 3, rent: 460, price: 160 },
            ],
          },
          mortgagedPrice: 110,
        },
        order: 17,
      },
      {
        type: "action",
        border: 2,
        direction: "horizontal",
        order: 18,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "France",
          price: 240,
          groupId: "4",
          rentData: {
            base: 50,
            houses: [50, 150, 375, 462.5],
            hotel: [550],
            upgradeItems: [
              { count: 1, rent: 160, price: 80 },
              { count: 2, rent: 250, price: 120 },
              { count: 3, rent: 460, price: 160 },
            ],
          },
          mortgagedPrice: 120,
        },
        order: 19,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Dock",
          price: 200,
          groupId: "8",
          calculateCustomRent: stationRentCalculator,
          mortgagedPrice: 100,
        },
        order: 20,
      },
      // Removed Belgium (order 26) from group 5
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "UAE",
          price: 260,
          groupId: "5",
          rentData: {
            base: 60,
            houses: [55, 165, 400, 550],
            hotel: [575],
            upgradeItems: [
              { count: 1, rent: 180, price: 80 },
              { count: 2, rent: 290, price: 120 },
              { count: 3, rent: 500, price: 160 },
            ],
          },
          mortgagedPrice: 130,
        },
        order: 21,
      },
      {
        type: "action",
        border: 2,
        direction: "horizontal",
        order: 22,
      },
      {
        type: "property",
        border: 2,
        direction: "horizontal",
        propertyDetails: {
          name: "Qatar",
          price: 280,
          groupId: "5",
          rentData: {
            base: 60,
            houses: [60, 180, 425, 600],
            hotel: [637.5],
            upgradeItems: [
              { count: 1, rent: 180, price: 80 },
              { count: 2, rent: 290, price: 120 },
              { count: 3, rent: 500, price: 160 },
            ],
          },
          mortgagedPrice: 140,
        },
        order: 23,
      },
      {
        type: "decision-hub",
        border: 2,
        direction: "horizontal",
        order: 24,
      },
      // Removed Finland (order 31) from group 6
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Sweden",
          price: 300,
          groupId: "6",
          rentData: {
            base: 70,
            houses: [65, 195, 450, 550],
            hotel: [637.5],
            upgradeItems: [
              { count: 1, rent: 230, price: 100 },
              { count: 2, rent: 380, price: 150 },
              { count: 3, rent: 650, price: 200 },
            ],
          },
          mortgagedPrice: 150,
        },
        order: 25,
      },
      {
        type: "action",
        border: 2,
        direction: "vertical",
        order: 26,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Finland",
          price: 320,
          groupId: "6",
          rentData: {
            base: 70,
            houses: [75, 225, 500, 600],
            hotel: [700],
            upgradeItems: [
              { count: 1, rent: 230, price: 100 },
              { count: 2, rent: 380, price: 150 },
              { count: 3, rent: 650, price: 200 },
            ],
          },
          mortgagedPrice: 160,
        },
        order: 27,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Bus Station",
          price: 200,
          groupId: "8",
          calculateCustomRent: stationRentCalculator,
          mortgagedPrice: 100,
        },
        order: 28,
      },
      // Removed United Kingdom (order 36) from group 7
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "UK",
          price: 350,
          groupId: "7",
          rentData: {
            base: 80,
            houses: [100, 300, 700, 850],
            hotel: [1000],
            upgradeItems: [
              { count: 1, rent: 260, price: 100 },
              { count: 2, rent: 410, price: 150 },
              { count: 3, rent: 680, price: 200 },
            ],
          },
          mortgagedPrice: 200,
        },
        order: 29,
      },
      {
        type: "action",
        border: 2,
        direction: "vertical",
        order: 30,
      },
      {
        type: "property",
        border: 2,
        direction: "vertical",
        propertyDetails: {
          name: "Ireland",
          price: 400,
          groupId: "7",
          rentData: {
            base: 80,
            houses: [100, 300, 700, 850],
            hotel: [1000],
            upgradeItems: [
              { count: 1, rent: 260, price: 100 },
              { count: 2, rent: 410, price: 150 },
              { count: 3, rent: 680, price: 200 },
            ],
          },
          mortgagedPrice: 200,
        },
        order: 31,
      },
    ],
    groups: [
      {
        color: "#8B5A2B",
        id: "0",
        type: "classic",
        withStrip: true,
        housePrice: 50,
        propertiesCount: 2,
      },
      {
        color: "#9B59B6",
        id: "1",
        type: "classic",
        withStrip: true,
        housePrice: 50,
        propertiesCount: 2,
      },
      {
        color: "#FF6F61",
        id: "2",
        type: "classic",
        withStrip: true,
        housePrice: 100,
        propertiesCount: 2,
      },
      {
        color: "#E08A3C",
        id: "3",
        type: "classic",
        withStrip: true,
        housePrice: 100,
        propertiesCount: 2,
      },
      {
        color: "#3B5998",
        id: "4",
        type: "classic",
        withStrip: true,
        housePrice: 150,
        propertiesCount: 2,
      },
      {
        color: "#D4AC0D",
        id: "5",
        type: "classic",
        withStrip: true,
        housePrice: 150,
        propertiesCount: 2,
      },
      {
        color: "#2ECC71",
        id: "6",
        type: "classic",
        withStrip: true,
        housePrice: 200,
        propertiesCount: 2,
      },
      {
        color: "#D32B2B",
        id: "7",
        type: "classic",
        withStrip: true,
        housePrice: 200,
        propertiesCount: 2,
      },
      {
        color: "#6E7681",
        id: "8",
        type: "classic",
        propertiesCount: 4,
      },
      {
        color: "#6E7681",
        id: "9",
        type: "classic",
      },
    ],
    size: { x: totalSizeX, y: totalSizeY },
  },
]
// console.log(JSON.stringify(mapDesigns[0]))
